<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.egitim"   :show_button="false" ></ContentHeader>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">


<div class="grid">

<template v-if="$store.state.flows.flow.educationpack">
  <div class="col-11">
  <ClickEditSelect title="Eğitim Paketi" :value="floweducationpack" :options="educationpacks" valkey="educationpack" @dataChanged="dataChanged"  />
  </div>
  <div class="col-1">
<Button type="button"  icon="pi pi-external-link"  class="p-button-primary p-button-outlined p-button-sm mt-3"  @click="gotoQuList" />
  </div>

</template>

<template v-else>
  <div class="col-12">
    <ClickEditSelect title="Soru Listesi" :value="floweducationpack" :options="educationpacks" valkey="educationpack" @dataChanged="dataChanged"  />
  </div>
</template>



</div>
<ClickEditSwitch  title="Kişi Bazlı Eğitim" :value="educationsettings.is_per_person" valkey="is_per_person" @dataChanged="settingsChanged" />
<ClickEditNumber  title="Max Katılımcı Sayısı" :value="educationsettings.participant_count" valkey="participant_count" @dataChanged="settingsChanged" v-show="educationsettings.is_per_person"  />
<ClickEditSwitch  title="Videoları sırayla izlet" :value="educationsettings.allow_unordered_display" valkey="allow_unordered_display" @dataChanged="settingsChanged" />


</div>
</template>
</div>



</template>

<script>
export default {

  name: 'FlowEducation',

  data () {
    return {
      loading:true,
      floweducationpack:null,
      educationpacks:[],
      selectededucationpack:{name:"Eğitim Paketi Seç",id:0},
      educationsettings:null,

    }
  },
  mounted()
  {
    //this.$store.dispatch('ui/setActiveTab',"verification") 
    
    this.getData()
  },
  
  methods:{
    async getData()
    {
      
        this.educationsettings = await this.$store.state.flows.flow.educationsettings
        let educationpacks = await this.generalApiGetWithoutLoader("educationpacks")
        console.log("educationpacks");
        console.log(educationpacks);
        for(let item of educationpacks)
        {
          if(item.brand_id == this.$store.state.flows.flow.brand_id)
          {

            
          }
          else
          {
            item.name = item.name+" - "+item.brand.name+" - kopyasını oluştur"
          }
          
        }
        this.educationpacks = await educationpacks
        await this.educationpacks.push({name:"Eğitim Paketi Oluştur",id:0})
        if(this.$store.state.flows.flow.educationpack)
        {
          this.floweducationpack = await this.$store.state.flows.flow.educationpack
        }
        else
        {
          this.floweducationpack = await {name:"Eğitim Paketi Oluştur",id:0}
        }
        
        

        console.log(this.educationpacks)
        this.loading = await false
    },
    settingsChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append("educationsettings_id",this.$store.state.flows.flow.educationsettings.id) 
      formdata.append(data.key,data.value) 
      this.generalSubmission(formdata,"flow/education_settings/"+this.$store.state.flows.flow.educationsettings.id,this.aftersettingsChanged)
    },
    aftersettingsChanged(response)
    {
      console.log(response.data)
      this.educationsettings  = response.data
      this.$store.state.flows.flow.educationsettings = response.data
    },
    dataChanged(data)
    {
      console.log(data)
      if(data.value==0)
      {
        this.gotoPage('flowNewEducationPack')
      }
      else
      {
        let formdata = new FormData()
        formdata.append("educationpack_id",data.value)
        formdata.append("flow_id",this.$route.params.id)
        this.generalSubmission(formdata,"educationpacks/select_flow",this.afterSubmit)
      }
    },
    afterSubmit(response)
    {
        console.log(response.data) 
        this.$store.dispatch('flows/setFlow',response.data)
        this.floweducationpack =  response.data.educationpack
      
    },
    gotoQuList()
    {
      console.log(this.$store.state.flows.flow.educationpack.id)
      this.gotoPage('Educationpack',{id:this.$store.state.flows.flow.educationpack.id})
    },
  }
};
</script>

<style lang="css" scoped>
</style>